/* Neko Toys — Header behaviors: drawer + modal toggles + cart count sync +
   sticky header-height tracking + universal back button.
   Vanilla JS, no dependencies. Loaded as defer from sections/header.liquid. */
(function () {
  'use strict';

  // -------------------- Drawer --------------------
  const drawer = document.getElementById('nekoDrawer');
  const overlay = document.getElementById('nekoDrawerOverlay');
  const trigger = document.getElementById('nekoHamburger');
  const closeBtn = document.getElementById('nekoDrawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // -------------------- Modals --------------------
  document.querySelectorAll('[data-modal-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const modal = document.getElementById(btn.dataset.modalTrigger);
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('.neko-modal').forEach(function (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-modal-close]')) {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  });

  // -------------------- ESC handler --------------------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    document.querySelectorAll('.neko-modal[aria-hidden="false"]').forEach(function (m) {
      m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });

  // -------------------- Footer relocation --------------------
  // When the header section's `show_footer_in_drawer` setting is ON, move
  // the rendered footer-group DOM from its position at body bottom into the
  // drawer's inner content area. Done at script load (DOM is already there
  // because this script is `defer`).
  if (drawer && drawer.dataset.showFooter === 'true') {
    const footerGroup = document.getElementById('shopify-section-group-footer-group');
    const drawerInner = drawer.querySelector('.neko-drawer__inner');
    if (footerGroup && drawerInner) {
      footerGroup.classList.add('neko-drawer__footer-relocated');
      drawerInner.appendChild(footerGroup);
    }
  }

  // -------------------- Cart count live updates --------------------
  // Listen for the Rise theme's cart change events (PubSub) so the badge stays
  // in sync when an item is added/removed via cart drawer or AJAX.
  function updateCartBadges(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  // Rise theme exposes PubSub for cart events. If not available (theme strip),
  // fall back to no-op — initial server-rendered count remains accurate.
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        updateCartBadges(event.cartData.item_count);
      }
    });
  }

  // Also poll /cart.js after a short delay if the page just loaded — ensures
  // accuracy if cookies / cart state updated since SSR.
  if ('fetch' in window) {
    setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && typeof data.item_count === 'number') {
            updateCartBadges(data.item_count);
          }
        })
        .catch(function () { /* ignore */ });
    }, 500);
  }

  // -------------------- Sticky header height tracking --------------------
  // Exposes --neko-header-height on :root so any sticky offset (tab bars,
  // back button, calendar chips) can sit flush below the sticky header.
  // neko-homepage.js also does this — running here ensures it's available on
  // every page, not just the homepage.
  var headerSection = document.querySelector('.shopify-section.neko-header-section');
  function syncHeaderHeight() {
    if (!headerSection) return;
    document.documentElement.style.setProperty(
      '--neko-header-height',
      headerSection.offsetHeight + 'px'
    );
  }
  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);

  // -------------------- Universal back button --------------------
  // A small floating pill that appears below the sticky header on every page
  // (except root and direct landings with no history). Calls history.back().
  // Hidden on desktop — browsers have a native back button; this is for mobile.
  //
  // Scroll-triggered: the button only becomes visible once the user has
  // scrolled ~60px — enough for the page title to have moved up under the
  // sticky header. This prevents the button from overlapping the title on
  // first load. It re-hides when the user scrolls back to the very top.
  var backBtn = document.getElementById('nekoBackBtn');
  if (backBtn) {
    var isRoot = window.location.pathname === '/' || window.location.pathname === '';
    var hasHistory = window.history.length > 1;

    if (hasHistory && !isRoot) {
      // Position flush below the sticky header.
      function positionBackBtn() {
        if (!headerSection) return;
        var timerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--neko-countdown-height')) || 0;
        backBtn.style.top = (headerSection.offsetHeight + timerHeight + 12) + 'px';
      }
      positionBackBtn();
      window.addEventListener('resize', positionBackBtn);
      window.addEventListener('load', positionBackBtn);

      // Show only after scrolling past the page title (~60px).
      // Re-hide when back at the very top so the title is always clear.
      var SCROLL_THRESHOLD = 60;
      function updateBackBtnVisibility() {
        backBtn.hidden = window.pageYOffset < SCROLL_THRESHOLD;
      }
      updateBackBtnVisibility(); // hidden on first load (pageYOffset = 0)
      window.addEventListener('scroll', updateBackBtnVisibility, { passive: true });
    }

    backBtn.addEventListener('click', function () {
      window.history.back();
    });
  }
})();
